"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ViewPostContentPlaceholder = function ViewPostContentPlaceholder(_ref) {
  var className = _ref.className;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_reactContentLoader.default, {
    height: 500,
    width: 1300,
    speed: 1,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb"
  }, _react.default.createElement("rect", {
    x: "20",
    y: "15",
    rx: "20",
    ry: "20",
    width: "640",
    height: "480"
  }), _react.default.createElement("rect", {
    x: "700",
    y: "17",
    rx: "10",
    ry: "10",
    width: "520",
    height: "33"
  }), _react.default.createElement("rect", {
    x: "700",
    y: "71",
    rx: "10",
    ry: "10",
    width: "415",
    height: "33"
  }), _react.default.createElement("rect", {
    x: "700",
    y: "125",
    rx: "10",
    ry: "10",
    width: "333",
    height: "20"
  }), _react.default.createElement("rect", {
    x: "700",
    y: "216",
    rx: "5",
    ry: "5",
    width: "295",
    height: "13"
  }), _react.default.createElement("rect", {
    x: "700",
    y: "251",
    rx: "5",
    ry: "5",
    width: "295",
    height: "13"
  })));
};

var _default = (0, _react.memo)(ViewPostContentPlaceholder);

exports.default = _default;